import _regeneratorRuntime from "/home/ubuntu/Local-Stitch-Front/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/ubuntu/Local-Stitch-Front/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import TourService from 'components/tour/_tour';
import { GetAllBranchesAPI } from 'api/space';
import { spaceActions } from 'store/space';

var Tour = function Tour() {
  return /*#__PURE__*/_jsx(TourService, {});
};

Tour.getInitialProps = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var store, branches;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            store = _ref.store;
            _context.next = 3;
            return GetAllBranchesAPI();

          case 3:
            branches = _context.sent;
            store.dispatch(spaceActions.getBranches(branches.data));
            return _context.abrupt("return", {});

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref2.apply(this, arguments);
  };
}();

export default Tour;